import React from 'react';
import {
  object, number,
} from 'yup';

import { Field,FieldArray } from 'formik';
import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';

const defaults = {
  name: '',
  desctiption: '',
  active: true,
  distances: [1000],
  tractions: [],
  image: '',
};

const FormLocation = ({
  location,
}) => (
  <FormResource
    {...{
      defaults,
      // schema: object({
      // }),
      stored: location,
      api: '/api/site/locations',
      // onSubmit: (v) => ({
      //   ...v,
      // }),
    }}
  >
    <FormGroup name="name" label="Name"/>
    <FormGroup name="description" label="Description"/>
    <div className="form-group">
      <label>Active</label>
      <FormCheckGroup
        name="active"
        type="checkbox"
        label=""
        asSwitch
      />
    </div>
    <div id="checkbox-group">Distances</div>
    <FieldArray
      name="locations"
      // push={push}
    >{(/*helpers*/) => (
        <div role="group" aria-labelledby="checkbox-group">
        <label><Field type="checkbox" name="distances" value="1000" /> 1000m</label>
        &nbsp;
        <label><Field type="checkbox" name="distances" value="2000" /> 2000m</label>
        &nbsp;
        <label><Field type="checkbox" name="distances" value="3000" /> 3000m </label>
      </div>    
      )
    }
    </FieldArray>
    <div id="checkbox-group">Traction</div>
    <FieldArray
      name="tractions"
      // push={push}
    >{(/*helpers*/) => (
        <div role="group" aria-labelledby="checkbox-group">
        <label><Field type="checkbox" name="tractions" value="wet" /> Wet</label>
        &nbsp;
        <label><Field type="checkbox" name="tractions" value="dry" /> Dry</label>
        &nbsp;
        <label><Field type="checkbox" name="tractions" value="sand" /> Sand</label>
      </div>    
      )
    }
    </FieldArray>    
    <FormGroup
        name="image"
        label="Image"
        as="coverImg"
        api="/api/site/locations/files"
    />

  </FormResource>
);

export default FormLocation;
